import React from 'react';
import PropTypes from 'prop-types';
import { FormFeedback } from 'reactstrap';
import classNames from 'classnames';

export default function FormErrors({ errors, className }) {
  const errorsArray = Array.isArray(errors) ? errors : [errors];
  return (
    <React.Fragment>
      {errorsArray.map(
        (error) => (
          <FormFeedback className={classNames(className, "invalid-feedback--with-icon-prefix")} key={error}>{error}</FormFeedback>
        )
      )}
    </React.Fragment>
  );
}

FormErrors.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  className: PropTypes.string
};
